import { createApi } from '@reduxjs/toolkit/query/react';

import { apiGocardlessConnections } from '~constants/api';

import { rtkBaseQueryWrapper, unwrap } from '~libs/axiosWrapper';
import { GocardlessConnection } from '~direct-debits/models';

export const connectionsApi = createApi({
  reducerPath: 'directDebitsConnectionsApi',
  baseQuery: rtkBaseQueryWrapper({ baseUrl: apiGocardlessConnections }),
  tagTypes: ['connections'],
  endpoints: (builder) => ({
    getConnections: builder.query<GocardlessConnection[], void>({
      query: () => ({ url: '', method: 'GET' }),
      transformResponse: (payload) => unwrap<GocardlessConnection[]>(payload),
      providesTags: [{ type: 'connections', id: 'LIST' }],
    }),
    getConnection: builder.query<GocardlessConnection, string>({
      query: (id) => ({ url: `/${id}`, method: 'GET' }),
      transformResponse: (payload) => unwrap<GocardlessConnection>(payload),
      providesTags: (_result, _error, id) => [{ type: 'connections', id }],
    }),
    createConnection: builder.mutation<GocardlessConnection, Partial<GocardlessConnection>>({
      query: (body) => ({ url: '', method: 'POST', body }),
      invalidatesTags: [{ type: 'connections', id: 'LIST' }],
      transformResponse: (payload) => unwrap<GocardlessConnection>(payload),
    }),
    disconnectConnection: builder.mutation<GocardlessConnection, string>({
      query: (id) => ({ url: `/${id}`, method: 'DELETE' }),
      invalidatesTags: (_result, _error, id) => [
        { type: 'connections', id: 'LIST' },
        { type: 'connections', id },
      ],
      transformResponse: (payload) => unwrap<GocardlessConnection>(payload),
    }),
  }),
});

export const {
  useGetConnectionsQuery,
  useGetConnectionQuery,
  useCreateConnectionMutation,
  useDisconnectConnectionMutation,
} = connectionsApi;
